import type { KeycloakConfig } from './types';

/**
 * Default configuration values for Keycloak integration
 */
export const defaultConfig: Partial<KeycloakConfig> = {
  redirectUri: typeof window !== 'undefined' ? window.location.origin + '/' : '/',
  postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin + '/' : '/',
  scope: 'openid profile email offline_access',

  features: {
    deviceFlow: false,
    sessionMonitor: true,
    autoRefresh: true,
  },

  silentRenew: {
    enabled: true,
    silentRedirectUri:
      typeof window !== 'undefined'
        ? window.location.origin + '/silent-renew.html'
        : '/silent-renew.html',
    thresholdSeconds: 300, // 5 minutes
    refreshStrategy: 'both', // Check on startup AND retry on 401
    maxRefreshTokenLifetime: 2592000, // 30 days in seconds
    showLoadingIndicator: false,
    loadingMessage: 'Refreshing session...',
    useRefreshToken: true,
  },

  advanced: {
    responseType: 'code',
    codeChallengeMethod: 'S256',
    loadUserInfo: true,
    automaticSilentSignIn: false,
    storageType: 'session',
  },

  events: {},
};
